/**
 * @file api/endpointConfigs.js
 * @description API functions for the /api/endpoint-configs resource.
 */

import apiClient from './client';

/**
 * Fetches all endpoint logging configurations.
 * @returns {Promise<Array>} Array of endpoint config objects.
 */
export const listEndpointConfigs = async () => {
  const res = await apiClient.get('/api/endpoint-configs');
  return res.data;
};

/**
 * Fetches a single endpoint config by ID.
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getEndpointConfig = async (id) => {
  const res = await apiClient.get(`/api/endpoint-configs/${id}`);
  return res.data;
};

/**
 * Creates a new endpoint logging config.
 * @param {{ path: string, method: string, logging_enabled?: boolean }} payload
 * @returns {Promise<Object>} Created endpoint config.
 */
export const createEndpointConfig = async (payload) => {
  const res = await apiClient.post('/api/endpoint-configs', payload);
  return res.data;
};

/**
 * Updates an endpoint config — typically used to toggle logging_enabled.
 * @param {number} id
 * @param {{ path?: string, method?: string, logging_enabled?: boolean }} payload
 * @returns {Promise<Object>} Updated endpoint config.
 */
export const updateEndpointConfig = async (id, payload) => {
  const res = await apiClient.put(`/api/endpoint-configs/${id}`, payload);
  return res.data;
};

/**
 * Deletes an endpoint config permanently.
 * @param {number} id
 * @returns {Promise<Object>} Confirmation message.
 */
export const deleteEndpointConfig = async (id) => {
  const res = await apiClient.delete(`/api/endpoint-configs/${id}`);
  return res.data;
};
